(function () {
  let currentLang = $('.controls__description').find('input.lang-input').eq(0).data('language');

  const Validation = (function () {

    return {
      isNum: function (obj) {
        let re = /^\d+$/;
        if (re.test(obj.val())) {
          obj.removeClass('_error');
        } else {
          obj.addClass('_error');
          return false;
        }
      },
      isEmail: function (obj) {
        let re = /^([\w\-]+(?:\.[\w\-]+)*)@((?:[\w\-]+\.)*\w[\w\-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        if (re.test(obj.val())) {
          obj.removeClass('_error');
          return true;
        } else {
          obj.addClass('_error');
          return false;
        }
      },
      isEmpty: function (obj) {
        if (obj.val().length) {
          obj.removeClass('_error');
        } else {
          obj.addClass('_error');
          return false;
        }
      },
      isIdentical: function (obj1, obj2) {
        if (obj1.val().length && obj1.val() === obj2.val()) {
          obj2.removeClass('_error');
          return true;
        } else {
          obj2.addClass('_error');
          return false;
        }
      }
    }

  }());

  const Messages = (function () {
    const $modalSuccess = $('.modal-success');
    const $modalAttention = $('.modal-attention');
    const $modalWarning = $('.modal-warning');

    function showAttentionMsg(message, time, fade) {
      $modalAttention.fadeIn(fade).find('.modal__text').html(message);
      setTimeout(function () {
        $modalAttention.fadeOut(fade);
      }, time);
    }
    function showWarningMsg(message, time, fade) {
      if (fade === undefined) {
        fade = 500;
      }
      $modalWarning.fadeIn(fade).find('.modal__text').html(message);
      setTimeout(function () {
        $modalWarning.fadeOut(fade);
      }, time);
    }
    function showSuccessMsg(message, time, fade) {
      if (fade === undefined) {
        fade = 500;
      }
      $modalSuccess.fadeIn(fade).find('.modal__text').html(message);
      setTimeout(function () {
        $modalSuccess.fadeOut(fade);
      }, time);
    }

    return {
      showSuccessMsg: function (message, time, fadeTime) {
        showSuccessMsg(message, time, fadeTime);
      },
      showAttentionMsg: function (message, time, fadeTime) {
        showAttentionMsg(message, time, fadeTime);
      },
      showWarningMsg: function (message, time, fadeTime) {
        showWarningMsg(message, time, fadeTime);
      }
    }

  }());

  $(function LogInForm () {
    const $loginForm = $("#login__form");
    let isBindValidationEvents = false;
    let isSignInFormValid = false;
    let isAllFilled = true;

    const checkLength = ($obj) => {
      const $that = $obj;
      if ($that.val().length < +$that.data('minlength')) {
        $that.addClass('_error');
        isSignInFormValid = false;
      } else {
        $that.removeClass('_error');
      }
    }

    const checkValidation = () => {
      isSignInFormValid = true;
      checkLength($loginForm.find('#login-pass'));
      if (Validation.isEmail($loginForm.find('#login-email')) === false) {
        isSignInFormValid = false;
      }
    }

    function bindValidationEvents() {
      $loginForm.find('#login-email').on('keyup blur', function () {
        Validation.isEmail($(this));
      });
      $loginForm.find('#login-pass').on('keyup blur', function () {
        checkLength($(this));
      });
    }

    $loginForm.submit(function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isSignInFormValid) {
        const formData = new FormData();
        formData.append('email', $loginForm.find("#login-email").val());
        formData.append('password', $loginForm.find("#login-pass").val());

        $.ajax({
          url: this.action,
          type: this.method,
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            if (window.location.pathname === '/en/' || window.location.pathname === '/ru/') {
              window.location.replace('/account');
            } else if (window.location.pathname.indexOf("/cart") > 0) {
              window.location.replace('/checkout');
            } else {
              window.location.reload();
            }
          },
          error: function(error) {
            Messages.showAttentionMsg(error.responseJSON.error, 3500);
          },
        });
      } else {
        $loginForm.find('input').each(function () {
          if ($(this).val().length === 0) {
            isAllFilled = false;
          }
        });
        if (isAllFilled && Validation.isEmail($loginForm.find('#login-email'))) {
          Messages.showAttentionMsg(currentLang === 'en' ? 'Password min length 6 symbols.' : 'Пароль должен быть не менее 6 символов.', 3500);
        } else {
          Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in the required fields.' : 'Пожалуйста, заполните обязательные поля.', 3500);
        }
      }
    });
  });

  $(function SignUpForm () {
    const $signupForm = $("#signup__form");
    let isBindValidationEvents = false;
    let isSignUpFormValid = false;

    const checkLength = ($obj) => {
      const $that = $obj;
      if ($that.val().length < +$that.data('minlength')) {
        isSignUpFormValid = false;
        $that.addClass('_error');
      } else {
        $that.removeClass('_error');
      }
    }

    const checkValidation = () => {
      isSignUpFormValid = true;
      $signupForm.find('.signup-pass').each(function () {
        if (Validation.isEmpty($(this)) === false) {
          isSignUpFormValid = false;
        }
      });
      $signupForm.find('.signup-pass').each(function () {
        checkLength($(this));
      });
      if (Validation.isIdentical($signupForm.find('#signup-pass-a'), $signupForm.find('#signup-pass-b')) === false) {
        isSignUpFormValid = false;
      }
      if (Validation.isEmail($signupForm.find('#signup-email')) === false) {
        isSignUpFormValid = false;
      }
    }

    function bindValidationEvents() {
      $signupForm.find('.signup-pass').on('keyup.checkIsEmpty blur.checkIsEmpty', function () {
        Validation.isEmpty($(this));
      });
      $signupForm.find('#signup-email').on('keyup.checkIsEmail blur.checkIsEmail', function () {
        Validation.isEmail($(this));
      });
      $signupForm.find('#signup-pass-a').on('keyup.checkIsIdentical blur.checkIsIdentical', function () {
        checkLength($(this));
        Validation.isIdentical($(this), $signupForm.find('#signup-pass-b'));
      });
      $signupForm.find('#signup-pass-b').on('keyup.checkIsIdentical blur.checkIsIdentical', function () {
        checkLength($(this));
        Validation.isIdentical($signupForm.find('#signup-pass-a'), $(this));
      });
    }

    $signupForm.submit(function(event) {
      let isAllFilled = true;
      let isMinLength = true;

      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isSignUpFormValid) {
        const formData = new FormData();
        formData.append('email', $signupForm.find("#signup-email").val());
        formData.append('password', $signupForm.find("#signup-pass-b").val());
        formData.append('subscribe', $signupForm.find("#promotions").prop('checked'));

        $.ajax({
          url: this.action,
          type: this.method,
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            window.location.replace('/account');
          },
          error: function(error) {
            Messages.showAttentionMsg(error.responseJSON.error, 3500);
          },
        });
      } else {
        $signupForm.find('input').each(function () {
          if ($(this).val().length === 0) {
            isAllFilled = false;
          }
        });
        $signupForm.find('input[type="password"]').each(function () {
          if ($(this).val().length < 6) {
            isMinLength = false;
          }
        });
        if (isAllFilled && Validation.isEmail($signupForm.find('#signup-email'))) {
          if (isMinLength) {
            Messages.showAttentionMsg(currentLang === 'en' ? 'Passwords do not match.' : 'Пароли не совпадают.', 3500);
          } else {
            Messages.showAttentionMsg(currentLang === 'en' ? 'Password min length 6 symbols.' : 'Пароль дожен быть не менее 6 символов.', 3500);
          }
        } else {
          Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in the required fields.' : 'Пожалуйста, заполните обязательные поля.', 3500);
        }
      }
    });
  });

  $(function SubscribeForm () {
    const $subscribeForm = $('#subscribe__form');
    let isSubscribeFormValid = false;
    let isBindValidationEvents = false;

    const checkValidation = () => {
      isSubscribeFormValid = Validation.isEmail($subscribeForm.find('#subscribe-email')) !== false;
    }

    function bindValidationEvents() {
      $subscribeForm.find('#subscribe-email').on('keyup.checkIsEmail blur.checkIsEmail', function () {
        Validation.isEmail($(this));
      });
    }

    $subscribeForm.submit(function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isSubscribeFormValid) {
        const formData = new FormData();
        formData.append('email', $subscribeForm.find("#subscribe-email").val());
        formData.append('locale', $subscribeForm.find("#subscribe-lang").data('lang'));
        formData.append('csrfmiddlewaretoken', $subscribeForm.find('input').attr('name', 'csrfmiddlewaretoken').val())
        $.ajax({
          url: $subscribeForm.attr('action'),
          type: "POST",
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            Messages.showSuccessMsg(currentLang === 'en' ? 'You have been subscribed to our newsletter.' : 'Вы подписались на нашу рассылку.', 3500);
          },
          error: function(error) {
            Messages.showAttentionMsg(error.responseJSON.email, 3500);
          },
        });
      } else {
        Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in valid email.' : 'Пожалуйста, введите валидный Email.', 3500);
      }
    });
  });

  $(function AddressForm() {
    const $addressForm = $(".address-form");
    const $addAddressForm = $('#add-address__form');
    const $editAddressForm = $('#edit-address__form');
    let isFormValid = false;
    let isBindValidationEvents = false;

    const checkValidation = () => {
      isFormValid = true;
      $addressForm.find('.address-form__field.required').each(function () {
        if (Validation.isEmpty($(this)) === false) {
          isFormValid = false;
        }
      });

      const selectedCountry = $addressForm.find('#select-country option:selected').val();
      if (selectedCountry === 'Country') {
        $addressForm.find('.choices__inner').addClass('_error');
        $addressForm.find('.choices__list').addClass('_error');
        isFormValid = false;
      } else {
        $addressForm.find('.choices__inner').removeClass('_error');
        $addressForm.find('.choices__list').removeClass('_error');
      }
    };

    function bindValidationEvents() {
      $addressForm.find('.address-form__field.required').on('keyup.checkIsEmpty blur.checkIsEmpty', function () {
        Validation.isEmpty($(this));
      });

      $addressForm.find(".choices__inner").on('click', function() {
        $(this).removeClass('_error');
        $addressForm.find('.choices__list').removeClass('_error');
      });
    }

    $addAddressForm.submit(function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isFormValid) {
        const formData = new FormData();
        $addressForm.find("input").each(function () {
          if (
            $(this).attr('id') !== 'billing-address'
            && $(this).attr('id') !== 'shipping-address'
            && $(this).attr('type') !== 'search'
          ) {
            formData.append($(this).attr('name'), $(this).val());
          }
        });
        formData.append('country', $addressForm.find('#select-country option:selected').val());
        formData.append('default_billing_address', $addressForm.find("#billing-address").prop('checked'));
        formData.append('default_shipping_address', $addressForm.find("#shipping-address").prop('checked'));

        $.ajax({
          url: this.action,
          type: this.method,
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            window.location.replace('/account/addresses');
          },
          error: function(error) {
            console.log('error', error);
            Messages.showAttentionMsg(currentLang === 'en' ? 'Something went wrong.' : 'Что-то пошло не так.', 5000);
          },
        });
      } else {
        Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in the required fields.' : 'Пожалуйста, заполните обязательные поля.', 5000);
      }
    });

    $editAddressForm.submit(function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isFormValid) {
        const formData = new FormData();
        $addressForm.find("input").each(function () {
          if (
            $(this).attr('id') !== 'billing-address'
            && $(this).attr('id') !== 'shipping-address'
            && $(this).attr('type') !== 'search'
          ) {
            formData.append($(this).attr('name'), $(this).val());
          }
        });
        formData.append('country', $addressForm.find('#select-country option:selected').val());
        formData.append('default_billing_address', $addressForm.find("#billing-address").prop('checked'));
        formData.append('default_shipping_address', $addressForm.find("#shipping-address").prop('checked'));

        $.ajax({
          url: this.action,
          type: this.method,
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            window.location.replace('/account/addresses');
          },
          error: function(error) {
            console.log(error);
            Messages.showAttentionMsg(currentLang === 'en' ? 'Something went wrong.' : 'Что-то пошло не так.', 5000);
          },
        });
      } else {
        Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in the required fields.' : 'Пожалуйста, заполните обязательные поля.', 5000);
      }
    });
  });

  $(function DeleteAddress() {
    const $deleteAddressForm = $('#delete-address');

    $deleteAddressForm.submit(function(event) {
      event.preventDefault();
      event.stopPropagation();

      const formData = new FormData();
      $deleteAddressForm.find("input").each(function () {
        formData.append($(this).attr('name'), $(this).val());
      });

      const $that = $(this);
      $.ajax({
        url: this.action,
        type: this.method,
        data: formData,
        processData: false,
        contentType: false,
        cache: false,
        success: function(response) {
          $that.parents('.address-card').fadeOut(500);
          setTimeout(function () {
            $that.parents('.address-card').remove();
          }, 510);
        },
        error: function(error) {
          console.log(error);
          Messages.showAttentionMsg(currentLang === 'en' ? 'Something went wrong.' : 'Что-то пошло не так.', 5000);
        },
      });
    });
  });

  $(function AccountDetails() {
    const $accountForm = $('#account__form');
    const $subscribe = $('.account__subscribe-checkbox');
    let isFormValid = false;
    let isBindValidationEvents = false;

    const checkValidation = () => {
      isFormValid = true;
      $accountForm.find('.required').each(function () {
        if (Validation.isEmpty($(this)) === false) {
          isFormValid = false;
        }
      });
      if (Validation.isEmail($accountForm.find('#account-email')) === false) {
        isFormValid = false;
      }
      if ($accountForm.find('#account-pass-a').val().length && $accountForm.find('#account-pass-b').val().length) {
        if (!$accountForm.find('#account-old-pass').val().length) {
          isFormValid = false;
        }
        if ($accountForm.find('#account-pass-a').val() !== $accountForm.find('#account-pass-b').val()) {
          isFormValid = false;
        }
      } else if ($accountForm.find('#account-pass-a').val().length || $accountForm.find('#account-pass-b').val().length) {
        isFormValid = false;
      }
    }

    function bindValidationEvents() {
      $accountForm.find('#account-email').on('keyup.checkIsEmail blur.checkIsEmail', function () {
        Validation.isEmail($(this));
      });
      $accountForm.find('.required').on('keyup.checkIsEmpty blur.checkIsEmpty', function () {
        Validation.isEmpty($(this));
      });
    }

    $accountForm.submit(function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isFormValid) {
        const formData = new FormData();
        $accountForm.find("input").each(function () {
          if ($(this).attr('id') !== 'account-pass-a' && $(this).attr('id') !== 'account-pass-b') {
            formData.append($(this).attr('name'), $(this).val());
          }
        });
        formData.append('new_password', $accountForm.find("#account-pass-a").val());
        formData.append('subscribe', $subscribe.find("#account-subscribe").prop('checked'));

        $.ajax({
          url: this.action,
          type: this.method,
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            Messages.showSuccessMsg(currentLang === 'en' ? 'All changes saved.' : 'Изменения Сохранены.', 3500);
          },
          error: function(error) {
            Messages.showAttentionMsg(error.responseJSON, 3500);
          },
        });
      } else {
        if (Validation.isEmail($accountForm.find('#account-email'))) {
          if ($accountForm.find('#account-pass-a').val().length && $accountForm.find('#account-pass-b').val().length) {
            if (!$accountForm.find('#account-old-pass').val().length) {
              Messages.showAttentionMsg(currentLang === 'en' ? 'Needs old and conf passwords.' : 'Needs old and conf passwords.', 3500);
            }
            if ($accountForm.find('#account-pass-a').val() !== $accountForm.find('#account-pass-b').val()) {
              Messages.showAttentionMsg(currentLang === 'en' ? 'Passwords do not match.' : 'Пароли не совпадают.', 3500);
            }
          } else if ($accountForm.find('#account-pass-a').val().length || $accountForm.find('#account-pass-b').val().length) {
            Messages.showAttentionMsg(currentLang === 'en' ? 'Needs old and conf passwords.' : 'Needs old and conf passwords.', 3500);
          }
        } else {
          Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in valid email.' : 'Пожалуйста, введите валидный Email.', 3500);
        }
      }
    });
  });

  $(function ContactForm() {
    const $contactForm = $('#contact-form');
    let isFormValid = false;
    let isBindValidationEvents = false;

    const checkValidation = () => {
      isFormValid = true;
      $contactForm.find('.required').each(function() {
        if (Validation.isEmpty($(this)) === false) {
          isFormValid = false;
        }
      });
      $contactForm.find('.contact-form__email').each(function() {
        if (Validation.isEmail($(this)) === false) {
          isFormValid = false;
        }
      });
    };

    function bindValidationEvents() {
      $contactForm.find('.required').on('keyup.checkIsEmpty blur.checkIsEmpty', function () {
        Validation.isEmpty($(this));
      });
      $contactForm.find('.contact-form__email').on('keyup.checkIsEmail blur.checkIsEmail', function () {
        Validation.isEmail($(this));
      });
    }

    $contactForm.submit(function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isFormValid) {
        const formData = new FormData();
        $contactForm.find("input").each(function () {
          formData.append($(this).attr('name'), $(this).val());
        });
        $contactForm.find('textarea').each(function () {
          formData.append($(this).attr('name'), $(this).val());
        });

        $.ajax({
          url: this.action,
          type: this.method,
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            console.log(response);
            $contactForm.find('input').val('');
            $contactForm.find('textarea').val('');
            Messages.showSuccessMsg(currentLang === 'en' ? 'Your message has been successfully sent.' : 'Ваше сообщение отправлено.', 3500);
          },
          error: function(error) {
            console.log(error);
            Messages.showAttentionMsg(currentLang === 'en' ? 'Something went wrong.' : 'Что-то пошло не так.', 3500);
          },
        });
      } else {
        Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in the required fields.' : 'Пожалуйста, заполните обязательные поля.', 3500);
      }
    });
  });

  $(function OrderForm() {
    const $checkoutForm = $("#checkout__form");
    const $orderSubmit = $("#order-submit");
    const $acceptTerms = $("#accept-terms");
    let isFormValid = false;
    let isBindValidationEvents = false;

    const checkValidation = () => {
      isFormValid = true;
      $checkoutForm.find('.address-form__field.required').each(function () {
        if (Validation.isEmpty($(this)) === false) {
          isFormValid = false;
        }
      });

      if (!$acceptTerms.prop('checked')) {
        $acceptTerms.parent().addClass('_error');
        isFormValid = false;
      }

      const shippingSelectedCountry = $checkoutForm.find('#shipping-select-country option:selected').val();
      const billingSelectedCountry = $checkoutForm.find('#billing-select-country option:selected').val();

      if (shippingSelectedCountry === 'Country') {
        $checkoutForm.find('#shipping-select-country').parent().addClass('_error');
        $checkoutForm.find('#shipping-select-country').next().addClass('_error');
        isFormValid = false;
      } else {
        $checkoutForm.find('#shipping-select-country').parent().removeClass('_error');
        $checkoutForm.find('#shipping-select-country').next().removeClass('_error');
      }

      if (billingSelectedCountry === 'Country') {
        $checkoutForm.find('#billing-select-country').parent().addClass('_error');
        $checkoutForm.find('#billing-select-country').next().addClass('_error');
        isFormValid = false;
      } else {
        $checkoutForm.find('#billing-select-country').parent().removeClass('_error');
        $checkoutForm.find('#billing-select-country').next().removeClass('_error');
      }
    };

    function bindValidationEvents() {
      $checkoutForm.find('.address-form__field.required').on('keyup.checkIsEmpty blur.checkIsEmpty', function () {
        Validation.isEmpty($(this));
      });

      $checkoutForm.find(".choices__inner").on('click', function() {
        $(this).removeClass('_error');
        $checkoutForm.find('.choices__list').removeClass('_error');
      });

      $acceptTerms.on('change', function() {
        $(this).parent().toggleClass('_error');
      });
    }

    $orderSubmit.on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isFormValid) {
        const formData = new FormData();

        const $csrf_token = $checkoutForm.find('input[name="csrfmiddlewaretoken"]').val();

        const currency = localStorage.getItem("currentCurrency");
        const deliveryCost = $('.delivery-type[data-checked="checked"]').data('cost');

        formData.append('payment', 'webpay');
        formData.append('currency', currency);
        formData.append('fedex_price', deliveryCost);

        $checkoutForm.find('.address-form__fieldset.delivery-address').eq(0).find("input").each(function () {
          if (
            $(this).attr('id') !== 'shipping-select-country'
            && $(this).attr('type') !== 'search'
          ) {
            formData.append(`shipping_${$(this).attr('name')}`, $(this).val());
          }
        });
        $checkoutForm.find('.address-form__fieldset.billing-address').eq(0).find("input").each(function () {
          if (
            $(this).attr('id') !== 'billing-select-country'
            && $(this).attr('type') !== 'search'
          ) {
            formData.append(`billing_${$(this).attr('name')}`, $(this).val());
          }
        });
        formData.append('billing_country', $checkoutForm.find('#billing-select-country option:selected').val());
        formData.append('shipping_country', $checkoutForm.find('#shipping-select-country option:selected').val());

        if (currency === 'byn' && $checkoutForm.find('#shipping-select-country option:selected').val() !== 'Belarus') {
          $('.modal-attention').addClass('_large');
          Messages.showAttentionMsg(currentLang === 'en' ?
            'When placing an order in BYN, delivery is carried out only on the territory of the Belarus. Please change your shipping address.' :
            'При оформлении заказа в BYN доставка осуществляется только по территории Беларуси. Пожалуйста, измените адрес доставки.', 6000);
          setTimeout(function () {
            $('.modal-attention').removeClass('_large');
          }, 7000);
        } else {
          $.ajax({
            url: $checkoutForm.attr('action'),
            type: $checkoutForm.attr('method'),
            headers:{"X-CSRFToken": $csrf_token},
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
            success: function(response) {
              window.location.replace(response.redirect_url);
            },
            error: function(error) {
              console.log(error);
              Messages.showAttentionMsg(currentLang === 'en' ? 'Something went wrong.' : 'Что-то пошло не так.', 5000);
            },
          });
        }
      } else {
        Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in the required fields.' : 'Пожалуйста, заполните обязательные поля.', 5000);
      }
    });
  });

  $(function AddToFavorite() {
    const $addToFavorite = $("#add-to-favorite__form");

    $('.add-to-favorites').click(function() {
      if ($(this).data('in-favorites')) {
        return
      }

      const formData = new FormData();
      $addToFavorite.find("input").each(function () {
        formData.append($(this).attr('name'), $(this).val());
      });

      $.ajax({
        url: $addToFavorite.attr('action'),
        type: $addToFavorite.attr('method'),
        data: formData,
        processData: false,
        contentType: false,
        cache: false,
        success: function(response) {
          $addToFavorite.find('.in-favorite._add').removeClass('_show');
          $addToFavorite.find('.in-favorite._added').addClass('_show');
        },
      });
    });
  });

  $(function RemoveFromFavorite() {
    const $removeFromFavorite = $(".remove-from-favorite");

    $removeFromFavorite.each(function() {
      $(this).submit(function(event) {
        event.preventDefault();
        event.stopPropagation();

        const $csrf_token = $removeFromFavorite.find('input[name="csrfmiddlewaretoken"]').val();

        const formData = new FormData();
        $(this).find('input').each(function () {
          formData.append($(this).attr('name'), $(this).val());
        });

        const $that = $(this);
        $.ajax({
          url: this.action,
          type: 'DELETE',
          headers:{"X-CSRFToken": $csrf_token},
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            $that.parents('.product').fadeOut(500);
            setTimeout(function () {
              $that.parents('.product').remove();
            }, 510);
          },
          error: function(error) {
            console.log(error);
            Messages.showAttentionMsg(currentLang === 'en' ? 'Something went wrong.' : 'Что-то пошло не так.', 5000);
          },
        });
      });
    });
  });

  $(function AddToCart() {
    const $container = $('#product-buttons');
    const $addToCart = $container.find('#add-to-cart');
    const $size = $container.find('.select-cart-size').find('.custom-select-name');
    const $customSize = localStorage.getItem('pintel_custom_size');

    const cartControlDesk = $("#header-cart-count").find('.controls__description');
    const cartControlMob = $("#header-cart-count").find('.controls__img');

    $addToCart.on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      if ($size.text() !== $size.data('no-selected')) {
        const formData = new FormData();
        formData.append('product', $addToCart.data('id'));
        formData.append('csrfmiddlewaretoken', $addToCart.data('token'));

        if (['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'].includes($size.data('size'))) {
          formData.append('size', $size.data('size'));
        } else {
          formData.append('custom_size', $customSize);
        }

        $.ajax({
          url: '/api/v1/cart/items/',
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            Messages.showSuccessMsg( currentLang === 'en' ? 'The item was successfully added to your shopping bag.' : 'Изделие добавлено в Вашу корзину.', 5000);
            if ($('#header-cart-count').length) {
              $.ajax({
                url: "/api/v1/cart/count/",
                type: "GET",
                success: function(result) {
                  cartControlDesk.find('.count').html(`(${result.count})`);
                  cartControlMob.find('.count').html(`${result.count}`);
                  cartControlDesk.addClass('_cart-not-empty');
                  cartControlMob.addClass('_cart-not-empty');
                }
              });
            }
          },
        });
      } else {
        Messages.showAttentionMsg(currentLang === 'en' ? 'Please select a size.' : 'Пожалуйста, выберите размер.', 3500);
      }
    });
  });

  $(function RemoveFromCart() {
    const $removeFromCart = $(".remove-from-cart");

    const cartControlDesk = $("#header-cart-count").find('.controls__description');
    const cartControlMob = $("#header-cart-count").find('.controls__img');

    $removeFromCart.each(function() {
      $(this).submit(function(event) {
        event.preventDefault();
        event.stopPropagation();

        const $csrf_token = $removeFromCart.find('input[name="csrfmiddlewaretoken"]').val();

        const formData = new FormData();
        $(this).find('input').each(function () {
          formData.append($(this).attr('name'), $(this).val());
        });

        const $that = $(this);
        $.ajax({
          url: this.action,
          type: 'DELETE',
          headers:{"X-CSRFToken": $csrf_token},
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            $that.parents('.card-item').fadeOut(500);
            setTimeout(function () {
              $that.parents('.card-item').remove();
            }, 510);

            if ($('#header-cart-count').length) {
              $.ajax({
                url: "/api/v1/cart/count/",
                type: "GET",
                success: function(result) {
                  if (result.count > 0) {
                    cartControlDesk.find('.count').html(`(${result.count})`);
                    cartControlMob.find('.count').html(`${result.count}`);
                  } else {
                    $("#header-cart-count").find('.count').html('');
                    cartControlDesk.removeClass('_cart-not-empty');
                    cartControlMob.removeClass('_cart-not-empty');
                  }
                }
              });
            }

            $.ajax({
              url: "/api/v1/cart/total/",
              type: "GET",
              success: function(result) {
                if (
                  result.total.total_byn === 0 ||
                  result.total.total_eur === 0 ||
                  result.total.total_rub === 0 ||
                  result.total.total_usd === 0
                ) {
                  $('.card-information').find('.buttons').hide();
                }

                $('.card-information').find('.price').each(function() {
                  switch ($(this).data('currency')) {
                    case 'byn':
                      return $(this).html(`${result.total.total_byn} BYN`);
                    case 'eur':
                      return $(this).html(`${result.total.total_eur} EUR`);
                    case 'usd':
                      return $(this).html(`${result.total.total_usd} USD`);
                    case 'rub':
                      return $(this).html(`${result.total.total_rub} RUB`);
                  }
                })
              }
            });
          },
          error: function(error) {
            console.log(error);
            Messages.showAttentionMsg(currentLang === 'en' ? 'Something went wrong.' : 'Что-то пошло не так.', 5000);
          },
        });
      });
    });
  });

  $(function ForgotPassword() {
    const $forgotPassForm = $('#forgot-password__form');
    let isFormValid = false;
    let isBindValidationEvents = false;

    const checkValidation = () => {
      isFormValid = Validation.isEmail($forgotPassForm.find('#forgot-password-email')) !== false;
    }

    function bindValidationEvents() {
      $forgotPassForm.find('#forgot-password-email').on('keyup.checkIsEmail blur.checkIsEmail', function () {
        Validation.isEmail($(this));
      });
    }

    $forgotPassForm.submit(function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isFormValid) {
        const formData = new FormData();
        formData.append('email', $forgotPassForm.find("#forgot-password-email").val());
        $.ajax({
          url: this.action,
          type: this.method,
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            Messages.showWarningMsg(currentLang === 'en' ? 'Check your email for restore password link.' : 'Проверьте свой Email.', 3500);
          },
          error: function(error) {
            console.log(error);
            Messages.showAttentionMsg('error', 3500);
          },
        });
      } else {
        if (Validation.isEmail($forgotPassForm.find('#forgot-password-email'))) {
          Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in the required fields.' : 'Пожалуйста, заполните обязательные поля.', 3500);
        } else {
          Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in valid email.' : 'Пожалуйста, введите валидный Email.', 3500);
        }
      }
    });
  });

  $(function ResetPassword() {
    const $resetPassForm = $('#reset-password__form');
    let isFormValid = false;
    let isBindValidationEvents = false;

    const checkLength = ($obj) => {
      const $that = $obj;
      if ($that.val().length < +$that.data('minlength')) {
        isFormValid = false;
        $that.addClass('_error');
      } else {
        $that.removeClass('_error');
      }
    }

    const checkValidation = () => {
      isFormValid = true;
      $resetPassForm.find('.required').each(function () {
        if (Validation.isEmpty($(this)) === false) {
          isFormValid = false;
        } else checkLength($(this))
      });
      if (Validation.isIdentical($resetPassForm.find('#password'), $resetPassForm.find('#confirm-password')) === false) {
        isFormValid = false;
      }
    }

    function bindValidationEvents() {
      $resetPassForm.find('.required').on('keyup.checkIsEmpty blur.checkIsEmpty', function () {
        Validation.isEmpty($(this));
      });
      $resetPassForm.find('#password').on('keyup.checkIsIdentical blur.checkIsIdentical', function () {
        checkLength($(this));
        Validation.isIdentical($resetPassForm.find('#confirm-password'), $(this));
      });
      $resetPassForm.find('#confirm-password').on('keyup.checkIsIdentical blur.checkIsIdentical', function () {
        checkLength($(this));
        Validation.isIdentical($(this), $resetPassForm.find('#password'));
      });
    }

    $resetPassForm.submit(function(event) {
      let isAllFilled = true;
      let isMinLength = true;

      event.preventDefault();
      event.stopPropagation();

      if (!isBindValidationEvents) {
        bindValidationEvents();
        isBindValidationEvents = true;
      }

      checkValidation();

      if (isFormValid) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const token = urlParams.get('token');

        const formData = new FormData();
        formData.append('new_password', $resetPassForm.find("#password").val());
        formData.append('token', token);

        $.ajax({
          url: this.action,
          type: this.method,
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: function(response) {
            window.location.replace('/');
          },
          error: function(error) {
            console.log(error);
            Messages.showAttentionMsg('error', 3500);
          },
        });
      } else {
        $resetPassForm.find('input').each(function () {
          if ($(this).val().length === 0) {
            isAllFilled = false;
          }
        });
        $resetPassForm.find('input[type="password"]').each(function () {
          if ($(this).val().length < 6) {
            isMinLength = false;
          }
        });
        if (isAllFilled) {
          if (isMinLength) {
            Messages.showAttentionMsg(currentLang === 'en' ? 'Passwords do not match.' : 'Пароли не совпадают.', 3500);
          } else {
            Messages.showAttentionMsg(currentLang === 'en' ? 'Password min length 6 symbols.' : 'Пароль дожен быть не менее 6 символов.', 3500);
          }
        } else {
          Messages.showAttentionMsg(currentLang === 'en' ? 'Please fill in the required fields.' : 'Пожалуйста, заполните обязательные поля.', 3500);
        }
      }
    });
  });

  $(function Search() {
    const search = (el) => {
      let urlOrigin = window.location.origin;
      let urlPathname = window.location.pathname;

      let locale = urlPathname.substring(0, 3);

      let request = "?search_query=" + el.val() + ""
      let newUrl = urlOrigin + locale + "/search" + "/catalog/" + request;
      $.ajax({
        url: newUrl,
        async: false,
        success: function(response) {
          const { count } = JSON.parse(response);
          if (count !== 0) {
            window.location.replace(`/catalog/${request}`)
          } else Messages.showWarningMsg(currentLang === 'en' ? 'Sorry! We couldn\'t find what you were looking for.' : 'Извините, ничего не найдено.', 3500);
        }
      });
    };

    $("#header-search-js").on('keypress', function (e) {
      if(e.which === 13) {
        e.preventDefault();
        search($("#header-search-js"));
      }
    });

    $('#search__form').submit(function(event) {
      event.preventDefault();
      event.stopPropagation();

      search($('#search__form').find('textarea').eq(0));
    });
  })
})();
